import React from "react";
import { useNavigate } from "react-router-dom";
import { RiArrowLeftLine } from "@remixicon/react";

export default function PageHeader({ title, subtitle, actions, back }) {
	const navigate = useNavigate();
	return (
		<div className="page-header">
			<div className="min-w-0">
				{back ? (
					<button type="button" className="page-back" onClick={() => (typeof back === "string" ? navigate(back) : navigate(-1))}>
						<RiArrowLeftLine size={16} /> Back
					</button>
				) : null}
				<h4 className="page-title">{title}</h4>
				{subtitle ? <div className="page-subtitle">{subtitle}</div> : null}
			</div>
			{actions ? <div className="page-actions">{actions}</div> : null}
		</div>
	);
}
